module.exports = __webpack_public_path__ + "static/media/google10.37e6e824.png";